import React, { Component } from 'react';
import service from '../../core/service';
import axios from 'axios';
import { AppConstants } from '../../core/constants';
import Cookies from 'js-cookie';

interface IProps {

}

interface IState {
  loading: boolean;
  offerDetails: any;
  anchorEl: null | HTMLElement;
  open: any,
  openModal: boolean,
  base64Data: any;
  base64Loading: boolean;
  pdf_type: string;
}

export class OffersDetailsController extends Component<IProps, IState> {

  arrowRef: any;

  constructor(props: any) {
    super(props);
    this.arrowRef = React.createRef();
  }

  state: IState = {
    loading: false,
    offerDetails: [],
    anchorEl: null,
    open: false,
    openModal: false,
    base64Data: "",
    base64Loading: false,
    pdf_type: ""

  };
  id: any = this.state.open ? 'simple-popper' : undefined;
  handleClick = (event: any) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event?.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event?.currentTarget) });
  };
  getDetails = async () => {
    const {
    } = this.state;

    this.setState({ loading: true })
    try {
      const response = await service.UniversalOffer.deatils(window.location.pathname.split("/")[2]);
      if (response) {
        this.setState({ offerDetails: response?.data?.data, loading: false, openModal: false })
        // return response;
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  async downloadPdf(pdf_type: string) {
    this.setState({ base64Loading: true, pdf_type: pdf_type });
    const { offerDetails } = this.state;
    try {
      const response = await axios.post(
        `${AppConstants.base_url_api}universalreport/`,
        {
          policy_id: offerDetails.id,
          insurance_type: offerDetails.plan_type,
          pdf_type: pdf_type,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `${Cookies.get('acto')}`,
          },
          responseType: "blob",
        }
      );
      if (response) {
        this.setState({ base64Loading: false })
        try {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          this.setState({ base64Data: url })
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "report.pdf");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error("خطایی رخ داد:", error);
          this.setState({ base64Loading: false })
        }
      }
    } catch (err: any) {
    }
  };
}
export default OffersDetailsController;